// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3mA6z","error":"Textarea_error__sCg31","readonly":"Textarea_readonly__3kseO","disabled":"Textarea_disabled__25eAp"};